import { Text } from 'react-native'
import { styled } from '~/core/styled'

import { convertLineHeight, convertPercentageToNumber } from '~/utils'

type BodyProps = React.ComponentPropsWithRef<typeof Body>

const Body = styled(Text, theme => {
  return {
    base: {
      fontSize: theme.fontSizeThreeandhalfpulse,
      color: theme.colorTextNeutralDefault,

      textDecorationLine: theme.textDecorationLineNone,
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
    },
    variants: {
      variant: {
        'default-bold': {
          fontFamily: theme.fontFamily.bold,
        },
        'underline-bold': {
          fontFamily: theme.fontFamily.bold,
          textDecorationLine: theme.textDecorationLineUnderline,
        },
        'default-semibold': {
          fontFamily: theme.fontFamily.semiBold,
        },
        'underline-semibold': {
          fontFamily: theme.fontFamily.semiBold,
          textDecorationLine: theme.textDecorationLineUnderline,
        },
        'default-regular': {
          fontFamily: theme.fontFamily.regular,
        },
      },
    },
  }
})

export { Body }
export type { BodyProps }
